module.exports = __webpack_public_path__ + "img/service-six-one.68bbb7f8.svg";